import { EventTypeProcess } from './EventTypeProcess';
import { EventTypeProcessInstance } from './EventTypeProcessInstance';

export class ProcessTreeItem {
    constructor(etPrc: EventTypeProcess, prcInst: EventTypeProcessInstance | null) {
        this.etPrc = etPrc;
        this.prcInst = prcInst;
    }
    etPrc: EventTypeProcess;
    prcInst: EventTypeProcessInstance | null;
}
